import { initAllCarousels } from '../../cmsComponents/carousel/carousel';

// eslint-disable-next-line import/prefer-default-export
export function initAllRecentlyViewedCarousels(): void {
  const RECENTLY_VIEWED = 'recently-viewed';
  initAllCarousels(RECENTLY_VIEWED);
}
